import CameraIcon from "@heroicons/react/24/outline/CameraIcon";
import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";
import AssetPreview from "components/asset-preview";
import Button from "components/button";
import IconButton from "components/icon-button";
import { TAKE_PHOTO_BUTTON_TEST_ID } from "constants/test";
import { FunctionComponent, Suspense, useRef, useState } from "react";
import { AssetType } from "types/asset";
import { Portal } from "react-portal";

interface PhotoTakerProps {
  onClose: () => void;
  modelUrl: string;
  type: AssetType;
  onPhoto: (file: File) => void;
}

const PhotoTaker: FunctionComponent<PhotoTakerProps> = ({ modelUrl, onClose, type, onPhoto }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [loaded, setLoaded] = useState(false);
  return (
    <Portal>
      <div className="fixed inset-0 z-20 flex bg-black/40">
        <div className="bg-white p-7 flex flex-col m-auto rounded-xl relative">
          <IconButton onClick={onClose} className="absolute top-3 right-3">
            <XMarkIcon className="w-7" />
          </IconButton>
          <div className="flex justify-between mb-4">
            <div className="font-bold leading-none text-xl capitalize">{type} Photo</div>
          </div>
          <div className="w-[400px] h-[400px]">
            <Suspense>
              <AssetPreview
                onLoad={(model) => {
                  setLoaded(true);
                }}
                ref={canvasRef}
                modelUrl={modelUrl}
                fillPercentage={80}
              />
            </Suspense>
          </div>
          <Button
            data-testid={!loaded ? undefined : TAKE_PHOTO_BUTTON_TEST_ID}
            onClick={() => {
              canvasRef.current?.toBlob(
                (blob) => {
                  if (!blob) return;
                  const file = new File([blob], "name.png", { type: "image/png" });
                  onPhoto(file);
                },
                "image/png",
                0.9
              );
            }}
            className="flex items-center justify-center mt-4"
          >
            <CameraIcon className="mr-3 w-5" />
            <div>Take a photo</div>
          </Button>
        </div>
      </div>
    </Portal>
  );
};

export default PhotoTaker;
